import { Component, Input } from '@angular/core';
import {Competitor, LengthRange, Lookups} from "@model";
import {AbstractComponent} from "../../abstract.component";

@Component({
  selector: 'app-competitor-order-item',
  templateUrl: './competitor-order-item.component.html',
  styleUrl: './competitor-order-item.component.scss',
  standalone: false
})
export class CompetitorOrderItemComponent  extends AbstractComponent {
  public readonly EXPANDABLE_BREAKPOINT: number = 2;

  @Input() competitor: Competitor | undefined;
  @Input() isTeam: boolean = false;
  @Input() currencyCode: string = "";
  @Input({required: true}) languages: Lookups[] = [];

  displayCompetitors: Competitor[] = [];
  dropdownOpened: Map<number, boolean> = new Map<number, boolean>();

  constructor() {
    super();
  }

  toggleDropdown(i: number) {
    this.dropdownOpened.set(i, !this.dropdownOpened.get(i));
  }

  ngOnInit() {
    if (this.competitor) {
      if (this.isTeam) {
        this.competitor.teamMembers?.forEach(tm => {
          if (tm.raceAdditionalPricingItems?.length || tm.raceCommercialItem) {
            this.displayCompetitors.push(tm)
          }
        })
      }
      else if (this.competitor.raceCommercialItem || this.competitor.raceAdditionalPricingItems?.length){
        this.displayCompetitors = [this.competitor];
      }
    }
    this.displayCompetitors.forEach((c,i)=>{
      this.dropdownOpened.set(i, false);
    });
  }

}
